import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  id?: string;
  as?: 'h1' | 'h2';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  id,
  as = 'h2'
}: SectionHeadingProps) {
  const Heading = as;
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-392" data-mp="363kvyri08kx2">
      {eyebrow ? <p className="mb-3 text-xs font-medium uppercase tracking-wider2 text-mauve" data-id="element-393" data-mp="3b0uwb26xmgzo">{eyebrow}</p> : null}
      <Heading id={id} className={`font-display font-semibold leading-tight text-ink ${as === 'h1' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl'}`} data-id="element-394" data-mp="3f1esa2frrek8">
        {title}
      </Heading>
      {description ? <p className="mt-4 text-[15px] leading-relaxed text-ink/70 sm:text-base" data-id="element-395" data-mp="3tsnnqs6cru5a">{description}</p> : null}
    </div>;
}